import { Link } from 'gatsby'
import styled, { css } from 'styled-components'
import {
  defaultColor,
  smBreakPoint,
  contrastDefaultColor,
  primaryColor
} from '~src/common/cssTips'

const buttonStyle = css`
  display: flex;
  font-size: 20px;
  font-weight: bold;
  line-height: 28px;
  border-radius: 28px;
  padding: 14px 30px;
  cursor: pointer;
  text-decoration: none;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  outline: none;

  &:hover {
    opacity: 0.8;
  }

  &[data-large="true"] {
    font-size: 20px;
    line-height: 28px;
    padding: 14px 30px;
  }

  @media screen and (max-width: ${smBreakPoint}) {
    font-size: 20px;
    &[data-large="true"] {
      font-size: 14px;
      padding: 12px 34px;
    }
  }

  svg {
    display: block;
  }
`

const noMarginStyle = css`
  margin-right: 0 !important;
`

export const Button = styled.button<{ $accent?: 'default' | 'primary' | 'secondary', $noMargin?: boolean }>`
  ${buttonStyle}
  background: ${({ $accent }) => $accent === 'primary' ? primaryColor : $accent === 'secondary' ? 'transparent' : defaultColor};
  color: ${({ $accent }) => $accent === 'secondary' ? primaryColor : contrastDefaultColor};
  border: solid 1px ${({ $accent }) => $accent === 'primary' ? primaryColor : $accent === 'secondary' ? primaryColor : defaultColor};

  ${props => props.$noMargin ? noMarginStyle : ''}
`

export const ButtonLink = styled(Link)<{ $accent?: 'default' | 'primary' | 'secondary', $noMargin?: boolean }>`
  ${buttonStyle}
  background: ${({ $accent }) => $accent === 'primary' ? primaryColor : $accent === 'secondary' ? 'transparent' : defaultColor};
  color: ${({ $accent }) => $accent === 'secondary' ? primaryColor : contrastDefaultColor};
  border: solid 1px ${({ $accent }) => $accent === 'primary' ? primaryColor : $accent === 'secondary' ? primaryColor : defaultColor};

  ${props => props.$noMargin ? noMarginStyle : ''}
`
